var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Model } from "../../model";
import { EncryptStorage } from "../../..";
import { Inject } from "@angular/core";
import { Events } from "ionic-angular";
var CustomFieldsModel = /** @class */ (function (_super) {
    __extends(CustomFieldsModel, _super);
    function CustomFieldsModel(storage, events) {
        return _super.call(this, storage, events, "custom-field-definition") || this;
    }
    /** @nocollapse */
    CustomFieldsModel.ctorParameters = function () { return [
        { type: EncryptStorage, decorators: [{ type: Inject, args: [EncryptStorage,] },] },
        { type: Events, decorators: [{ type: Inject, args: [Events,] },] },
    ]; };
    return CustomFieldsModel;
}(Model));
export { CustomFieldsModel };
//# sourceMappingURL=custom-fields-model.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/models/items/custom-fields/custom-fields-model.js
// module id = 377
// module chunks = 14